import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase"; // Firebase config
import { Snackbar } from "@mui/material";
import loginBg from "../assets/login-bg.jpg"; // Import local image

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setShowSnackbar(false); // Reset snackbar visibility
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/"); // Redirect to the homepage
    } catch (error) {
      setErrorMessage("Login failed: " + error.message);
      setShowSnackbar(true); // Show snackbar with error message
    }
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: `url(${loginBg})`,
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <form
        onSubmit={handleLogin}
        className="relative bg-white p-8 rounded shadow-lg max-w-sm w-full z-10"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
          AppJingle PMS
        </h2>
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Email</label>
          <input
            type="email"
            className="w-full p-3 border rounded shadow-sm focus:ring focus:ring-blue-300 focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 font-medium">Password</label>
          <input
            type="password"
            className="w-full p-3 border rounded shadow-sm focus:ring focus:ring-blue-300 focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition duration-200 shadow-lg"
        >
          Login
        </button>
      </form>

      {/* Snackbar for messages */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        message={errorMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </div>
  );
};

export default Login;
